import { render, staticRenderFns } from "./upload-2.vue?vue&type=template&id=aaf9b0de&"
import script from "./upload-2.vue?vue&type=script&lang=js&"
export * from "./upload-2.vue?vue&type=script&lang=js&"
import style0 from "./upload-2.vue?vue&type=style&index=0&id=aaf9b0de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports